/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../services/globalsettingsservice.ts" />
/// <reference path="iscreencontroller.d.ts" />

module App.Common.Controllers {
	'use strict';

	export class UserMessagesController {

		public model: Hca.HiLO.Model.IUserMessages;

		public static $inject = ['app.common.services.userMessagesService'];

		constructor(userMessages: Common.Services.UserMessagesService) {
			this.model = userMessages.messages;
		}

	}

}